// extracted by mini-css-extract-plugin
export default {"loader":"LoaderButton_loader__ZFNES","loader-container":"LoaderButton_loader-container__I7ERL","spin89345":"LoaderButton_spin89345__yRPPX"};